import { OutgoigMessagePayload } from '@go-shared/types/kafkaLogs';
import { timeToAgoLocal, getLocaleDateTimeStringUTC } from '@go-shared/lib/time';
import React, { useState } from 'react';
import { Popup, InlineIcon, TextButton } from '@spark-labs/avocado-ui';
import { capitalize } from '@go-shared/lib/string';

export const KafkaOutgoingMessage: React.FC<OutgoigMessagePayload> = props => {
  const [timeToAgo, setTimeToAgo] = useState(false);
  const [detailsVisible, setDetailsVisible] = useState(false);
  const { createdAt, topic, payload } = props;

  const displayDate = (creationDate: string) => {
    if (timeToAgo) {
      return timeToAgoLocal(new Date(creationDate), new Date());
    } else {
      return getLocaleDateTimeStringUTC(new Date(creationDate));
    }
  };
  return (
    <div className="w-full px-4 inline-flex space-between items-center record-row">
      <span className="text-grey-dark mr-8 items-center flex">
        <span className="time-span">{createdAt ? displayDate(createdAt) : 'No date'}</span>
        <button onClick={() => setTimeToAgo(!timeToAgo)}>
          <InlineIcon name="clock" className="text-grey w-5 h-5" />
        </button>
      </span>
      <span className="w-1/6 justify-center inline-flex">
        <span className="action-pill ">
          <span
            className={`rounded-full w-full text-center uppercase px-5
                  py-2 text-xs font-bold mr-3  `}
          >
            {topic}
          </span>
        </span>
      </span>
      <div className="ml-3 mr-8 flex flex-col">
        {payload.name ? <span>{payload.name}</span> : <span>No name</span>}
      </div>
      <span className="ml-auto mr-32  flex items-center">
        {payload ? (
          <TextButton
            className="text-blue-dark font-semibold"
            onClick={() => setDetailsVisible(!detailsVisible)}
          >
            Details
            {detailsVisible && (
              <Popup title={'Details'} onClose={() => setDetailsVisible(false)}>
                <ReadableBody body={props} />
              </Popup>
            )}
          </TextButton>
        ) : (
          <h4 className="text-grey m-0">No details available</h4>
        )}
      </span>
    </div>
  );
};

const ReadableBody: React.FC<{ body: any }> = ({ body = {} }) => {
  const [tab, setTab] = useState<'general' | 'payload'>('general');
  const payload: any[] = Object.keys(body.payload).map(k => {
    return { key: k, value: body.payload[k] };
  });
  const keyValues = Object.keys(body).map(k => {
    return { key: k, value: body[k] };
  });

  const activeClassname = 'border-b-2 border-grey';
  return (
    <>
      <div className="w-full flex px-5">
        <span className="mr-5">
          <TextButton
            className={tab === 'general' ? activeClassname : 'border-transparent border-b-2'}
            onClick={e => {
              e.stopPropagation();
              setTab('general');
            }}
          >
            General
          </TextButton>
        </span>
        <span>
          <TextButton
            className={tab === 'payload' ? activeClassname : 'border-transparent border-b-2'}
            onClick={e => {
              e.stopPropagation();
              setTab('payload');
            }}
          >
            Payload
          </TextButton>
        </span>
      </div>
      <div className="details-body px-5 py-4">
        <div className="text-left">
          {(tab === 'general' ? keyValues : payload).map((data, i) => {
            if (data.key === '_id') return <></>;
            if (tab === 'general' && data.key === 'payload') return <></>;
            return (
              <div className="mb-4 w-full border-b border-grey-light" key={i}>
                <span
                  className="font-regular py-3
                                text-grey-darker"
                >
                  {capitalize(data.key)}
                </span>
                <pre className="font-regular ml-2 py-3 text-grey-dark">
                  {JSON.stringify(data.value, undefined, 2).replace(/"/g, '')}
                </pre>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};
